export enum SecondaryRoles {
    CUSTOMER = 1,
    ADMIN = 2,
    SYSTEM_INTEGRATOR = 3,
    SECONDARY_USER = 4,
    SERVICE_ENGINEER = 1,
    THIRD_PARTY_INTEGRATOR = 6,
  }
   